// These values should match the settings in /scss/_transitions.scss
export const speedFast = 100;
export const speedMedium = 200;
export const speedSlow = 300;
